import React, { useState } from "react";
import styled from "styled-components";

interface CopyValueProps {
    value: string;
}

const Wrapper = styled.span`
    position: relative;
    display: block;
    cursor: pointer;
`;

const Tooltip = styled.div<{ visible: boolean; copied: boolean; active: boolean }>`
    position: absolute;
    left: 50%;
    top: -2rem;
    transform: translateX(-50%) scale(${props => props.active ? 0.95 : 1});
    background: ${props => props.copied ? "#2196f3" : "#222"};
    color: #f2f2f2;
    padding: .3rem .7rem;
    border-radius: .3rem;
    font-size: .9rem;
    white-space: nowrap;
    user-select: none;
    opacity: ${props => props.visible ? 1 : 0};
    pointer-events: none;
    transition:
            background 0.1s,
            opacity .15s,
            transform 0.08s;
    z-index: 10;
    box-shadow: ${props => props.active ? "inset 0 0 8px #1976d2" : "none"};
`;

export function CopyValue({ value }: CopyValueProps) {
    const [hover, setHover] = useState(false);
    const [copied, setCopied] = useState(false);
    const [active, setActive] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(value);
        setCopied(true);
        setActive(true);
        setTimeout(() => setActive(false), 120);
    };

    const handleMouseLeave = () => {
        setHover(false);
        setCopied(false);
        setActive(false);
    };

    return (
        <Wrapper
            onMouseEnter={() => setHover(true)}
            onMouseLeave={handleMouseLeave}
            onClick={handleCopy}
        >
            <Tooltip visible={hover} copied={copied} active={active}>
                Click to copy
            </Tooltip>
            <span style={{userSelect: 'none', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block'}}>{value}</span>
        </Wrapper>
    );
}